module.exports = __webpack_public_path__ + "img/nadia-kona.6d0dfe01.jpg";